export const HIDE_RESET_DIALOG = 'lumahealth/LoginPage/HIDE_RESET_DIALOG';
export const SHOW_RESET_DIALOG = 'lumahealth/LoginPage/SHOW_RESET_DIALOG';
export const SHOW_TWO_FACTOR_FORM = 'lumahealth/LoginPage/SHOW_TWO_FACTOR_FORM';
export const HIDE_TWO_FACTOR_FORM = 'lumahealth/LoginPage/HIDE_TWO_FACTOR_FORM';
